module.exports = __webpack_public_path__ + "static/media/CourseTimeTrackedGreen.80f1c88d.svg";